__turbopack_context__.v({
  "productAttributes": "u4ut1G_productAttributes",
  "productAttributesContainer": "u4ut1G_productAttributesContainer",
  "videoIcon": "u4ut1G_videoIcon",
});
